import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Image from 'next/legacy/image'
import styled from 'styled-components'
import WrapWithText from '@/components/ui/WrapWithText'
import { device } from '@/common/constants/device'
import BaseLink from '@/components/common/BaseLink'
import { useTranslations } from 'next-intl'

const APPS_HREF = '/apps'

export const ToolsContainer = styled.div`
  width: 100%;
`

export const ToolsFeatures = styled.section`
  margin-bottom: 60px;
`

export const ToolsFeaturesList = styled.div`
  display: grid;
  margin-top: 32px;
  gap: 8px;

  @media ${device.laptop} {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    column-gap: 32px;
  }
`

export const LandingListItem = styled.div`
  background: white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90px;
  border: 1px solid var(--divider);
  position: relative;

  @media ${device.laptop} {
    height: 120px;
  }
`

export const LandingListItemImg = styled.div`
  position: relative;
  height: 40px;
  width: 40px;
  overflow: hidden;
  border-radius: 8px;

  @media ${device.laptop} {
    height: 60px;
    width: 60px;
  }
`
export const LandingTopWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const LandingListItemContent = styled.div`
  padding: 20px 0;
`

export const LandingListItemTitle = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #0e0e0e;
`

const Title = styled.h2`
  font-size: 2em;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.44px;
  margin-bottom: 12px;

  @media ${device.laptop} {
    font-size: 2.5em;
  }
`

const ToolsFeaturesLabel = styled.div`
  font-size: 12px;
  line-height: 2em;
  font-weight: 500;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 10;
  color: black;
`

const Tools = () => {
  const t = useTranslations('tools')
  const { user } = useSelector((state) => state.user)

  const featuresData = useMemo(() => {
    const linkToAds = user ? '/ads' : '/register'
    const linkToApps = user ? APPS_HREF : '/register'

    return [
      {
        title: { value: 'Facebook Ads Spy', isTranslate: false },
        linkHref: linkToAds,
        tarrif: { type: 'tryFreeDemo', icon: 'tools-premium' },
      },
      {
        title: { value: 'Instagram Ads Spy', isTranslate: false },
        linkHref: linkToAds,
        tarrif: { type: 'tryFreeDemo', icon: 'tools-premium' },
      },
      {
        title: { value: 'Audience Network Ads Spy', isTranslate: false },
        linkHref: linkToAds,
        tarrif: { type: 'tryFreeDemo', icon: 'tools-premium' },
      },
      {
        title: { value: 'Mobile Apps Ads Spy', isTranslate: false },
        linkHref: linkToApps,
        tarrif: { type: 'tryFreeDemo', icon: 'tools-premium' },
      },
      {
        title: { value: 'toolsGenerateUtm', isTranslate: true },
        linkHref: '/tools/utm-builder',
        tarrif: { type: 'free', icon: 'tools-free' },
      },
      {
        title: { value: 'toolsUniqCreative', isTranslate: true },
        linkHref: '/tools/uniq-creative',
        tarrif: { type: 'free', icon: 'tools-free' },
      },
      { title: { value: 'Wiki', isTranslate: false }, linkHref: '/help/wiki' },
      { title: { value: 'FAQ', isTranslate: false }, linkHref: '/help/faq' },
    ]
  }, [user])

  const getCorrectIterationCount = (index) => {
    let currentIndex = index + 1
    return currentIndex === 1 ? '' : currentIndex++
  }

  return (
    <ToolsContainer>
      <ToolsFeatures>
        <Title>{t('tryAdheartTools')}</Title>
        <WrapWithText
          textKey="noPaymentRequired"
          bgColor="purple"
          color="purple"
          fileName="tools"
        />
        <ToolsFeaturesList>
          {featuresData.map((feature, index) => (
            <BaseLink
              key={feature.title.value}
              isChangePath={false}
              href={feature.linkHref}
            >
              <LandingListItem>
                <LandingListItemContent>
                  <LandingTopWrap>
                    <LandingListItemImg>
                      <Image
                        layout="fill"
                        quality="90"
                        src={`/_next_static/tools/tools-features-img${getCorrectIterationCount(
                          index
                        )}.png`}
                        alt={feature.title.value}
                      />
                    </LandingListItemImg>
                    <LandingListItemTitle>
                      {feature.title.isTranslate
                        ? t(feature.title.value)
                        : feature.title.value}
                    </LandingListItemTitle>
                  </LandingTopWrap>
                </LandingListItemContent>
                {feature.tarrif && (
                  <ToolsFeaturesLabel>
                    {t(feature.tarrif.type)}
                    <Image
                      width={24}
                      height={24}
                      src={`/_next_static/tools/${feature.tarrif.icon}.png`}
                      alt={feature.tarrif.type}
                    />
                  </ToolsFeaturesLabel>
                )}
              </LandingListItem>
            </BaseLink>
          ))}
        </ToolsFeaturesList>
      </ToolsFeatures>
    </ToolsContainer>
  )
}

export default Tools
